module.exports = __webpack_public_path__ + "img/U_1_correct.8db05ca9.png";